/* eslint-disable import/prefer-default-export */
const prefix = 'brands'

export const SET_BRANDS = `${prefix}/SET_BRANDS`
